import { Link } from "react-router-dom";
import { Button } from "@direct-campaign/ui";

export function PricingPage() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-20 space-y-16">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold tracking-tight">Simple, campaign-friendly pricing</h1>
        <p className="text-xl text-muted-foreground">
          We&apos;re currently in early access. Pricing details coming soon.
        </p>
      </div>

      <div className="max-w-sm mx-auto rounded-lg border bg-card p-8 text-center space-y-6">
        <div className="space-y-1">
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Early Access</p>
          <p className="text-4xl font-bold">Free</p>
          <p className="text-sm text-muted-foreground">during our beta period</p>
        </div>

        <ul className="text-sm text-left space-y-2 text-muted-foreground">
          {[
            "Unlimited volunteers",
            "Unlimited voter records",
            "Walkbook creation & assignment",
            "Offline mobile PWA",
            "Real-time sync & reporting",
            "Priority support",
          ].map((item) => (
            <li key={item} className="flex items-center gap-2">
              <span className="text-foreground">✓</span> {item}
            </li>
          ))}
        </ul>

        <Button className="w-full" asChild>
          <Link to="/request-access">Request access</Link>
        </Button>
      </div>
    </div>
  );
}
